import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerEmailCreateSlice = createApi({
    reducerPath: "customerEmailCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        customerEmailCreate: builder.mutation({
            query: (data) => ({ url: "/order-management/api/v1/email/create", method: "POST", body: data }),
        }),
    }),
});

export const { useCustomerEmailCreateMutation } = customerEmailCreateSlice;
